import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';
import { HSLogoColorIcon } from '../../../assets/icons';
import useQuery from '../../../hooks/useQuery';
import RequestAccountForm from '../RequestAccountForm/RequestAccountForm';
import SignInForm from '../SignInForm/SignInForm';
import styles from './FormContainer.styles';


const useStyles = makeStyles(styles);
const FormContainer = () => {
  const classes = useStyles();
  const testid = 'form';
  const queryParams = useQuery();

  
  const requestAccess = queryParams.has('request-access');

  return (
    <div className={classes.container}>
      <HSLogoColorIcon className={classes.hsLogo} />
      <Typography
        variant="h1"
        className={classes.title}
        data-testid={`${testid}__title`}
      >
        {requestAccess
          ? 'Request an Account'
          : 'Welcome to the HealthySteps - Medicaid Return on Investment Calculator'}
      </Typography>
      {!requestAccess && (
        <Typography
          classes={{ root: classes.subtitle }}
          data-testid={`${testid}__subtitle`}
        >
          Please enter your details below
        </Typography>
      )}
      {requestAccess ? <RequestAccountForm /> : <SignInForm />}
      <Typography className={classes.version}>
        {process.env.REACT_APP_VERSION}
      </Typography>
    </div>
  );
};

export default FormContainer;
